import Vue from 'vue'
import Vuex from 'vuex'
Vue.use(Vuex);

export default new Vuex.Store({
  state: {
    logined: false,
    menu: ['使用说明', '注册', '写信', '查询', '登录'],
    newUser: true,
    userType:'',
    userInfo: {},//在实名认证和修改个人信息时更改
    userDetail:{},
    localData: {},
    datas:{},
    addresses: [],
    gotoRegister: {
      show: false,
      allowClose: true,
      content: ''
    }
  },
  mutations: {
    toggleLogin(state, arg){
      state.logined = arg.login;
      if(arg.menus && arg.menus.length){
        state.menu = arg.menus
      }else{
        if(arg.login){
          state.menu = ['使用说明', '写信', '查询', '我的']
        }else{
          state.menu = ['使用说明', '注册', '写信', '查询', '登录']
        }
      }
      state.newUser = arg.newUser;
      state.userInfo = arg.userInfo;
    },
    changeUserPass(state, arg){
      state.newUser = arg.newUser;
    },
    changeUserInfo(state, arg){
      state.userInfo = arg.newUser;
    },
    updateDatas(state, arg){
      state.localData = arg
    },
    getuserDetail(state, arg){
      state.userDetail = arg;
    },
    setDatas(state, arg){
      state.datas = arg.data;
      state.localData = arg.data;
      state.addresses = arg.data.districts;
    },
    changeUserType(state, arg){
      state.userType=arg
    },
    changeUserstat(state, arg){
      state.userDetail.status=arg
      state.userInfo.status=arg
    },
    setMenu(state,menu){
      state.menu = menu;
    },
    setGotoRegister(state, arg){
      state.gotoRegister = arg;
    },
  },
  actions: {}
})



// WEBPACK FOOTER //
// ./src/vuex/index.js